<script setup lang="ts">
import type { ScaleLinear } from 'd3';
import type { ScatterChartData, ScatterChartOptions } from '../index.vue';

// ================================================ Props
const props = defineProps<{
  loading: boolean;
  data: ScatterChartData;
  xScale: ScaleLinear<number, number>;
  yScale: ScaleLinear<number, number>;
  options: ScatterChartOptions;
}>();

// ================================================ Methods
const getPointStyle = (point: { x: number; y: number; color?: string; originalIndex?: number }) => {
  const xPercent = props.xScale(point.x);
  const yPercent = props.yScale(point.y);

  // Assurer que les points ne sont pas coupés aux bords
  const clampedX = Math.max(0.5, Math.min(99.5, xPercent));
  const clampedY = Math.max(0.5, Math.min(99.5, yPercent));

  return {
    left: `${clampedX}%`,
    top: `${clampedY}%`,
    backgroundColor: point.color || '#3b82f6',
  };
};

// Points are now purely visual, tooltip is handled by the tooltip module
</script>

<template>
  <div class="absolute inset-0 w-full h-full">
    <div
      v-for="(point, index) in data.points"
      :key="index"
      :style="getPointStyle(point)"
      class="absolute w-2 h-2 rounded-full transform -translate-x-1/2 -translate-y-1/2 hover:scale-125 transition-transform duration-200"
    />
  </div>
</template>
